//-- copyright
// OpenProject is an open source project management software.
// Copyright (C) the OpenProject GmbH
//
// This program is free software; you can redistribute it and/or
// modify it under the terms of the GNU General Public License version 3.
//
// See COPYRIGHT and LICENSE files for more details.
//++

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UserEditFieldComponent } from './user-edit-field.component';
import { IUserAutocompleteItem } from 'core-app/shared/components/autocompleter/user-autocompleter/user-autocompleter.component';
import { HalResource } from 'core-app/features/hal/resources/hal-resource';
// GPE: declared in OpenprojectFieldsModule (next to UserEditFieldComponent) so its
// template gets the CommonModule directive scope — without it, *ngIf="url" is a no-op
// and the autocompleter is never created (the field renders empty).

// GPE (gov.ao): the work package assignees field. Reuses the single-assignee
// op-user-autocompleter (avatars, invite-to-project) in multiple mode; the only
// difference from UserEditFieldComponent is that the value is an array of user
// HAL resources. Registered for WorkPackage 'assignees' only, so other []User
// fields keep the generic multi-select.
@Component({
  templateUrl: './user-multi-edit-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMultiEditFieldComponent extends UserEditFieldComponent {
  // (change) from the multi autocompleter emits the full selected array.
  // Distinct name from the base single-value onModelChange (incompatible signature).
  public onModelChanges(users?:IUserAutocompleteItem[]):unknown {
    const list = (users || []).map((user) =>
      this.halResourceService.createHalResourceOfType('user', { ...user }));
    this.value = list;
    return this.handler.handleUserSubmit();
  }

  // (userInvited) emits ONE HalResource, not an array — append it to the
  // current set instead of replacing it (which onModelChange would do).
  public onUserInvited(user:HalResource):unknown {
    const current = Array.isArray(this.value) ? (this.value as HalResource[]).slice() : [];
    current.push(this.halResourceService.createHalResourceOfType('user', { ...user }));
    this.value = current;
    return this.handler.handleUserSubmit();
  }
}
